import React from "react";
import PropTypes from "prop-types";
import { Avatar, Box, Paper, Typography } from "@material-ui/core";
import { BRAND } from "src/theme/brandTokens";

/**
 * Tarjeta de un miembro del equipo snapshot de una propuesta V2.
 * Bio completa sin truncar (contexto admin, no consumer).
 */
const TarjetaMiembroEquipo = ({ miembro }) => (
  <Paper
    elevation={0}
    variant="outlined"
    sx={{
      p: 2,
      display: "flex",
      gap: 2,
      alignItems: "flex-start",
      borderRadius: 2,
      height: "100%",
    }}
  >
    {miembro.fotoUrl ? (
      <Avatar src={miembro.fotoUrl} sx={{ width: 56, height: 56 }} />
    ) : (
      <Avatar sx={{ width: 56, height: 56, bgcolor: BRAND.color.primary }}>
        {(miembro.nombre || "?")[0].toUpperCase()}
      </Avatar>
    )}
    <Box sx={{ minWidth: 0, flex: 1 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
        {miembro.nombre || "—"}
      </Typography>
      {miembro.rolDisplay && (
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{ fontWeight: 600, mb: 0.5 }}
        >
          {miembro.rolDisplay}
        </Typography>
      )}
      {miembro.descripcionExperiencia && (
        <Typography
          variant="body2"
          sx={{ whiteSpace: "pre-wrap", mt: 0.5, color: "text.secondary" }}
        >
          {miembro.descripcionExperiencia}
        </Typography>
      )}
    </Box>
  </Paper>
);

TarjetaMiembroEquipo.propTypes = {
  miembro: PropTypes.shape({
    nombre: PropTypes.string,
    rolDisplay: PropTypes.string,
    fotoUrl: PropTypes.string,
    descripcionExperiencia: PropTypes.string,
    orden: PropTypes.number,
  }).isRequired,
};

export default TarjetaMiembroEquipo;
